import React from "react";
import { Button } from "../../elements";
import { UploadFileStatusEnum } from "../../../utils/uwp";

// --- 子元件：對話框按鈕 ---
// 職責：根據狀態顯示不同的操作按鈕
const DialogButtons = React.memo(({ submitStatus, uploadStatus, theme, handleSubmit, t }) => {
  if (submitStatus === 0) {
    if (
      uploadStatus > UploadFileStatusEnum.PackageEnd &&
      uploadStatus !== UploadFileStatusEnum.Canceled &&
      uploadStatus !== UploadFileStatusEnum.Canceling
    ) {
      return (
        <Button role="button" id="submit" theme={theme} className="text-base h-[32px] w-[132px] px-4 border font-semibold" onClick={handleSubmit}>
          {t("cancel")}
        </Button>
      );
    }
    return null;
  }

  if (submitStatus > 0) {
    const buttonTextMap = {
      1: t("done"),
      2: t("ok"),
      3: t("ok"),
      4: t("done"),
    };
    return (
      <Button role="button" id="submit" isFocus={() => false} theme={theme} isEnabled={true} className="h-[32px] w-[132px] text-base px-4 border font-semibold" onClick={handleSubmit}>
        {buttonTextMap[submitStatus]}
      </Button>
    );
  }
  return null;
});

export default DialogButtons;
